import { IconInterface } from '../interfaces/icon.interface';

const SypacToast = (props: IconInterface) => {
	const { width = 41, height = 40 } = props;

	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 41 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect
				x="0.5"
				width="40"
				height="40"
				rx="9.09091"
				fill="url(#paint0_linear_22324_372631)"
			/>
			<path
				d="M16.9805 15.6269C17.2054 15.2333 17.599 15.0084 18.0488 15.0084L27.7481 15.0365C28.226 15.0365 28.6055 15.3036 28.8164 15.655C29.0132 16.0065 29.0554 16.4703 28.8164 16.892L23.9387 25.284C23.7138 25.6776 23.3202 25.9025 22.8703 25.9025C22.4065 25.9025 22.041 25.6776 21.8161 25.284L19.3983 21.081L16.9805 16.878C16.7416 16.4563 16.7416 16.0346 16.9805 15.6269ZM30.8968 14.4743C30.5876 13.9401 30.1377 13.4762 29.5755 13.1389C29.0413 12.8296 28.4228 12.6609 27.7621 12.6609C24.5291 12.6469 21.296 12.6328 18.0629 12.6328C15.9825 12.6328 14.4362 14.3056 14.4222 16.2454C14.4222 16.5547 14.4644 16.8639 14.5346 17.1591C13.9302 17.37 13.4241 17.7917 13.0868 18.368L9.96616 23.7377C9.432 24.6514 9.50229 25.6776 9.95211 26.4788C10.416 27.28 11.2735 27.8564 12.3277 27.8564L18.5408 27.8704C19.2156 27.8704 19.82 27.6596 20.312 27.2379C20.5369 27.4487 20.7759 27.6455 21.043 27.8001C22.7157 28.7701 24.9508 28.2781 25.991 26.4788C27.6216 23.6815 29.2381 20.8842 30.8687 18.1009C31.2061 17.5246 31.3747 16.9202 31.3747 16.2876C31.3747 15.6269 31.2061 15.0084 30.8968 14.4743ZM12.0185 25.284C11.9622 25.1856 11.9482 25.0591 12.0185 24.9185C13.0587 23.1333 14.0989 21.3621 15.1672 19.591C15.3218 19.3239 15.5889 19.2536 15.7576 19.5628L17.3038 22.2618L18.8501 24.9607C19.0188 25.2559 18.822 25.4527 18.5268 25.4527C16.4604 25.4808 14.4081 25.4808 12.3418 25.4808C12.1871 25.4667 12.0747 25.3824 12.0185 25.284Z"
				fill="white"
			/>
			<mask
				id="mask0_22324_372631"
				maskUnits="userSpaceOnUse"
				x="13"
				y="10"
				width="11"
				height="11"
			>
				<mask
					id="mask1_22324_372631"
					maskUnits="userSpaceOnUse"
					x="13"
					y="10"
					width="11"
					height="11"
				>
					<path
						d="M17.413 10L23.9635 13.8094L20.0979 20.4442L13.5474 16.6348L17.413 10Z"
						fill="url(#paint1_linear_22324_372631)"
					/>
				</mask>
				<g mask="url(#mask1_22324_372631)">
					<path
						d="M17.413 10L23.9635 13.8094L20.0979 20.4442L13.5474 16.6348L17.413 10Z"
						fill="url(#paint2_linear_22324_372631)"
					/>
				</g>
			</mask>
			<g mask="url(#mask0_22324_372631)">
				<path
					d="M23.1931 15.0365L21.8156 12.6469L18.0343 12.6328C15.9539 12.6328 14.4076 14.3056 14.3936 16.2454C14.3936 16.5547 14.4357 16.8639 14.506 17.1591C15.7571 16.7234 17.1628 17.2294 17.8234 18.3821L16.9519 16.8639C16.4459 15.9924 17.1065 15.0225 18.0202 15.0225L23.1931 15.0365Z"
					fill="url(#paint3_linear_22324_372631)"
				/>
			</g>
			<mask
				id="mask2_22324_372631"
				maskUnits="userSpaceOnUse"
				x="12"
				y="22"
				width="9"
				height="9"
			>
				<mask
					id="mask3_22324_372631"
					maskUnits="userSpaceOnUse"
					x="12"
					y="22"
					width="9"
					height="9"
				>
					<path
						d="M14.9828 22.6328L20.9991 26.133L18.5532 30.35L12.5369 26.8499L14.9828 22.6328Z"
						fill="url(#paint4_linear_22324_372631)"
					/>
				</mask>
				<g mask="url(#mask3_22324_372631)">
					<path
						d="M14.9828 22.6328L20.9991 26.133L18.5532 30.35L12.5369 26.8499L14.9828 22.6328Z"
						fill="url(#paint5_linear_22324_372631)"
					/>
				</g>
			</mask>
			<g mask="url(#mask2_22324_372631)">
				<path
					d="M19.72 26.4556L18.8484 24.9375C19.0171 25.2327 18.8203 25.4295 18.5251 25.4295C16.8102 25.4435 15.1093 25.4576 13.4084 25.4576L14.3784 27.8473L18.5392 27.8613C19.2139 27.8613 19.8184 27.6505 20.3104 27.2288C20.0854 27.0039 19.8887 26.7508 19.72 26.4556Z"
					fill="url(#paint6_linear_22324_372631)"
				/>
			</g>
			<defs>
				<linearGradient
					id="paint0_linear_22324_372631"
					x1="0.5"
					y1="20"
					x2="40.5"
					y2="20"
					gradientUnits="userSpaceOnUse"
				>
					<stop offset="0.0220187" stopColor="#494C83" />
					<stop offset="1" stopColor="#7693F4" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_22324_372631"
					x1="12.6724"
					y1="18.7156"
					x2="20.2503"
					y2="14.3731"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset="1" />
				</linearGradient>
				<linearGradient
					id="paint2_linear_22324_372631"
					x1="12.6724"
					y1="18.7156"
					x2="20.2503"
					y2="14.3731"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset="1" stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint3_linear_22324_372631"
					x1="14.5246"
					y1="17.1654"
					x2="22.0224"
					y2="12.9587"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopOpacity="0.5" />
					<stop offset="1" stopColor="#363976" stopOpacity="0" />
				</linearGradient>
				<linearGradient
					id="paint4_linear_22324_372631"
					x1="19.6112"
					y1="24.8666"
					x2="15.6124"
					y2="27.1577"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset="1" />
				</linearGradient>
				<linearGradient
					id="paint5_linear_22324_372631"
					x1="19.6112"
					y1="24.8666"
					x2="15.6124"
					y2="27.1577"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset="1" stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint6_linear_22324_372631"
					x1="19.1223"
					y1="25.7482"
					x2="13.8948"
					y2="27.4112"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopOpacity="0.5" />
					<stop offset="1" stopColor="#363976" stopOpacity="0" />
				</linearGradient>
			</defs>
		</svg>
	);
};
export default SypacToast;
